module.exports = Object.freeze({
    ACTION_RECEIVE_PAGE: 'RECEIVE_PAGE',
    ACTION_CAROUSEL_INDEX: 'SET_HERO_CAROUSEL_INDEX',
    ACTION_HERO_EXPANDED: 'SET_HERO_EXPANDED',
    ACTION_HERO_CHANGING_SIZE: 'SET_HERO_CHANGING_SIZE',
    ACTION_TOGGLE_BUYER_ASSURANCE_SHOW_INFO: 'TOGGLE_BUYER_ASSURANCE_SHOW_INFO',
    ACTION_DELETE_BUYER_ASSURANCE_COOKIE: 'DELETE_BUYER_ASSURANCE_COOKIE',
    ACTION_PRINT_PAGE: 'SET_PRINT_PAGE'
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/actions/pdpActionsConstants.es.js